import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { PlatexUserAlert } from 'src/app/models/platexUserAlert';
import { SessionService } from 'src/app/services/session-service';
import { UserService } from 'src/app/services/user-service';

@Component({
  selector: 'pla-account-alerts',
  templateUrl: './account-alerts.component.html',
  styleUrls: ['./account-alerts.component.scss'],
})
export class AccountAlertsComponent implements OnInit {
  public newAlert: PlatexUserAlert = new PlatexUserAlert();
  public regStyleControl: FormControl = new FormControl();
  public budgetControl: FormControl = new FormControl();
  public saleTypeControl: FormControl = new FormControl();

  public alerts: PlatexUserAlert[] = [];
  public loading: boolean = true;
  public createAlertLoading: boolean = false;
  public actionError: string = '';
  private alertStatusLoading: { [key: string]: boolean } = {};
  private alertDeleteLoading: { [key: string]: boolean } = {};

  constructor(
    private sessionService: SessionService,
    private userService: UserService
  ) {
    this.loading = true;
    this.userService.alertsUpdated.subscribe((_: PlatexUserAlert[]) => {
      this.alerts = this.mapAlerts(_);
      this.loading = false;
    });
    if (!this.sessionService.isLoggedIn()) return;
    this.getAlerts();
  }

  ngOnInit(): void {}

  private getAlerts(): void {
    if (this.alerts.length > 0) return;
    this.loading = true;
    this.userService.getPlatexUserAlerts((_: PlatexUserAlert[]) => {
      this.alerts = this.mapAlerts(_);
      this.loading = false;
    });
  }

  private mapAlerts(alerts: PlatexUserAlert[]): PlatexUserAlert[] {
    if (alerts == null) return [];
    return alerts.map((a) => {
      if (a.registrationStyle == null || a.registrationStyle == '')
        a.registrationStyle = 'All Styles';
      else
        a.registrationStyle = a.registrationStyle
          .replace('current', 'Current')
          .replace('prefix', 'Prefix')
          .replace('suffix', 'Suffix')
          .replace('dateless', 'Dateless')
          .split(',')
          .join(', ');

      if (a.status == null || a.status == '') a.status = 'active';
      return a;
    });
  }

  public addNewAlertHandler(): void {
    if (this.createAlertLoading) return;
    this.actionError = '';
    const alertTerm = (this.newAlert.term || '').trim();
    const selectedStyles = (this.regStyleControl.value as string[]) || [];
    if (alertTerm == '') {
      this.actionError = 'Please enter a term.';
      return;
    }

    this.newAlert.term = alertTerm;
    this.newAlert.registrationStyle = selectedStyles.join(',');
    // this.newAlert.budget = (this.budgetControl.value as []).join(',');
    // this.newAlert.saleType = this.saleTypeControl.value;
    this.createAlertLoading = true;
    this.userService.addAlert(this.newAlert, (_alerts: PlatexUserAlert[]) => {
      this.newAlert = new PlatexUserAlert();
      this.regStyleControl.reset();
      this.budgetControl.reset();
      this.saleTypeControl.reset();
      this.createAlertLoading = false;
    }, (message: string) => {
      this.createAlertLoading = false;
      this.actionError = message;
    });
  }

  public deleteAlert(alert: PlatexUserAlert): void {
    const actionKey = this.getAlertActionKey(alert);
    if (this.alertDeleteLoading[actionKey]) return;

    this.actionError = '';
    this.alertDeleteLoading[actionKey] = true;
    this.userService.removeAlert(alert, (_: PlatexUserAlert[]) => {
      this.alertDeleteLoading[actionKey] = false;
      console.log('alert removed');
    }, () => {
      this.alertDeleteLoading[actionKey] = false;
      this.actionError = 'Unable to cancel alert right now. Please try again.';
    });
  }

  public isAlertActive(alert: PlatexUserAlert): boolean {
    return !alert.status || alert.status.toLowerCase() == 'active';
  }

  public toggleAlertStatus(alert: PlatexUserAlert): void {
    const actionKey = this.getAlertActionKey(alert);
    if (this.alertStatusLoading[actionKey]) return;

    const nextStatus = this.isAlertActive(alert) ? 'paused' : 'active';
    this.actionError = '';
    this.alertStatusLoading[actionKey] = true;
    this.userService.updateAlertStatus(alert, nextStatus, (_: PlatexUserAlert[]) => {
      this.alertStatusLoading[actionKey] = false;
      console.log(`alert ${nextStatus}`);
    }, () => {
      this.alertStatusLoading[actionKey] = false;
      this.actionError = `Unable to ${nextStatus} alert right now. Please try again.`;
    });
  }

  public isAlertStatusLoading(alert: PlatexUserAlert): boolean {
    return !!this.alertStatusLoading[this.getAlertActionKey(alert)];
  }

  public isAlertDeleteLoading(alert: PlatexUserAlert): boolean {
    return !!this.alertDeleteLoading[this.getAlertActionKey(alert)];
  }

  private getAlertActionKey(alert: PlatexUserAlert): string {
    if (alert.id > 0) return `id-${alert.id}`;
    return `term-${alert.term || ''}`;
  }
}
